<template>
  <el-steps
    :active="step"
    align-center
  >
    <el-step :title="$t('ppwc.p3')" />
    <el-step :title="$t('ppwc.p4')" />
    <el-step :title="$t('ppwc.p5')" />
    <el-step :title="$t('ppwc.p6')" />
  </el-steps>
</template>

<script>
export default {
  props: ['step'],
  data() {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-steps {
  width: 650px;
  margin: 0px auto 35px auto;
  /deep/.el-step.is-horizontal .el-step__line {
    top: 16px;
    left: 62%;
    right: -38%;
    background-color: #d1caca;
  }
  /deep/.el-step__head.is-finish {
    color: #1f9d56;
    border-color: #1f9d56;
    .el-step__icon {
      width: 31px;
      height: 31px;
      background: url('/official/static/img/events/activate/2.png') no-repeat center center;
      border: none;
    }
  }
  /deep/.el-step__title.is-finish {
    color: #1f9d56;
  }
  /deep/.el-step__title.is-process {
    font-weight: normal;
  }
  /deep/.el-step__head {
    color: #C0C4CC;
    border-color: #C0C4CC;
    .el-step__icon {
      width: 31px;
      height: 31px;
      background: url('/official/static/img/events/activate/1.png') no-repeat center center;
      border: none;
    }
  }
  /deep/.el-step__title {
    color: #C0C4CC;
  }
  /deep/.el-step__icon-inner {
    color: #fff;
    font-size: 16px;
    font-weight: normal;
  }
  /deep/.el-step {
    width: 25%;
  }
}
</style>
